import { useEffect, useState } from 'react'

import axios from 'axios'

import './ReactRuleSearch.scss'
import { ReactRuleSearchProps } from './types'
import { customParse } from '../../utils/helper-util'
import IsInEditorText from '../shared/IsInEditorText'

const ReactRuleSearch = (props: ReactRuleSearchProps): JSX.Element => {
  const { isInEditor = false, contentPath, pagefolderpath, findRule } = props
  const [ruleSearchRes, setRuleSearchRes] = useState<string>('')
  useEffect(() => {
    axios({
      method: 'get',
      url: `/bin/ruleSearch?contentPath=${contentPath}&pagefolderpath=${pagefolderpath}&findRule=${findRule}`
    })
      .then((res) => {
        setRuleSearchRes(res?.data)
      })
      .catch((err) => {
        console.error(err)
      })
    return () => {
      setRuleSearchRes('')
    }
  }, [])

  return (
    <div data-testid={`react-rule-search`} className={`react-rule-search`}>
      {IsInEditorText(isInEditor, 'React Rule Search')}
      {ruleSearchRes && IsInEditorText(isInEditor, customParse(ruleSearchRes) as string)}
    </div>
  )
}
export default ReactRuleSearch
